<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.Basic_Website_Information')"></pageTitle>
        <div class="cardlist">
          <Row>
            <Col span="24">
              <Form ref="form" :label-width="130" label-colon>
                <!-- <Row :gutter="15">
                  <Col :xl="12" :xxl="8">
                    <FormItem :label="$t('website_logo')+'(en)'">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,1)"
                        type="drag"
                        action
                        style="display: inline-block;width:250px;height: 100px;"
                      >
                        <div class="demo-upload-list" v-if="form.en_web_logo != ''">
                          <template>
                            <img :src="form.en_web_logo" />
                          </template>
                        </div>
                        <div v-else style="width: 250px;height:100px;line-height: 115px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 160*45 "}}</div>
                    </FormItem>
                  </Col>
                  <Col :xl="12" :xxl="8">
                    <FormItem :label="$t('website_logo')+'(繁体)'">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,2)"
                        type="drag"
                        action
                        style="display: inline-block;width:250px;height: 100px;"
                      >
                        <div class="demo-upload-list" v-if="form['zh-tw_web_logo'] != ''">
                          <template>
                            <img :src="form['zh-tw_web_logo']" />
                          </template>
                        </div>
                        <div v-else style="width: 250px;height:100px;line-height: 115px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 160*45 "}}</div>
                    </FormItem>
                  </Col>
                  <Col :xl="12" :xxl="8">
                    <FormItem :label="$t('website_logo')+'(简体)'">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :before-upload="(value)=>handleBeforeUpload(value,3)"
                        type="drag"
                        action
                        style="display: inline-block;width:250px;height: 100px;"
                      >
                        <div class="demo-upload-list" v-if="form['zh-cn_web_logo'] != ''">
                          <template>
                            <img :src="form['zh-cn_web_logo']" />
                          </template>
                        </div>
                        <div v-else style="width: 250px;height:100px;line-height: 115px;">
                          <Icon type="ios-add-circle-outline" size="30" style="color:#6096FF" />
                        </div>
                      </Upload>
                      <div class="photo_tip">{{$t('photo_tip')+" 160*45 "}}</div>
                    </FormItem>
                  </Col>
                </Row>-->

                <FormItem :label="$t('Info.copyright') ">
                  <div class="copyrightList">
                    <span>{{form.copyright}}</span>
                    <div class="edit">
                      <Icon
                        class="cursor_p"
                        type="md-create"
                        size="24"
                        color="#1F8FC8"
                        @click="handleClick(1)"
                      />
                    </div>
                  </div>
                </FormItem>
                <FormItem :label="$t('Info.homepage') ">
                  <div class="copyrightList">
                    <span>{{form.homepage}}</span>
                    <div class="edit">
                      <Icon
                        class="cursor_p"
                        type="md-create"
                        size="24"
                        color="#1F8FC8"
                        @click="handleClick(3)"
                      />
                    </div>
                  </div>
                </FormItem>
                <FormItem class="formItem" :label="$t('Info.keywords') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(7)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data8"></Table>
                </div>
                <FormItem class="formItem" :label="$t('Info.description') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(6)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data7"></Table>
                </div>
                <FormItem class="formItem" :label="$t('concept') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(8)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data9"></Table>
                </div>
                <FormItem class="formItem" :label="$t('Info.contactUs') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(5)"
                    />
                  </div>
                </FormItem>
                <div class="condition contactUs mg-bottom30">
                  <Table :columns="columns" :data="data6"></Table>
                </div>
                <FormItem class="formItem" :label="$t('Info.condition') ">
                  <div class="edit">
                    <!-- <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="handleClick(2)"
                    />-->
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(4)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data"></Table>
                </div>
                <FormItem class="formItem" :label="$t('Info.user_agreement') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(2)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data3"></Table>
                </div>
                <FormItem class="formItem" :label="$t('Info.privacy_policy') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(3)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data4"></Table>
                </div>
                <!-- <FormItem class="formItem" :label="$t('Info.terms_us') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(4)"
                    />
                  </div>
                </FormItem>
                <div class="condition mg-bottom30">
                  <Table :columns="columns" :data="data5"></Table>
                </div>-->
                <!-- <FormItem class="formItem" :label="$t('Info.homeContactUs') ">
                  <div class="edit">
                    <Icon
                      class="cursor_p"
                      type="md-create"
                      size="24"
                      color="#1F8FC8"
                      @click="contactUsClick(1)"
                    />
                  </div>
                </FormItem>
                <div class="condition contactUs mg-bottom30">
                  <Table :columns="columns2" :data="data2"></Table>
                </div>-->
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <condition
      v-if="modal"
      :type="type"
      :modal="modal"
      :conditionObj="JSON.stringify(obj)"
      @ok="save"
      @cancel="cancel"
    ></condition>
    <contactUs
      v-if="modal2"
      :type="type"
      :modal="modal2"
      :contactUsObj="JSON.stringify(obj)"
      @ok="save2"
      @cancel="cancel2"
    ></contactUs>
  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import condition from "./module/condition_edit";
import contactUs from "./module/contactUs_edit";
export default {
  name: "info",
  components: {
    pageTitle,
    condition,
    contactUs,
  },
  data () {
    return {
      columns: [
        { title: this.$t('content') + '(en)', tooltip: true, key: 'en' },
        { title: this.$t('content') + '(繁体)', tooltip: true, key: 'tw' },
        { title: this.$t('content') + '(简体)', tooltip: true, key: 'cn' },
      ],
      columns2: [
        { width: 140, title: this.$t('cat_id'), tooltip: true, key: 'title' },
        { title: this.$t('content') + '(en)', tooltip: true, key: 'en' },
        { title: this.$t('content') + '(繁体)', tooltip: true, key: 'tw' },
        { title: this.$t('content') + '(简体)', tooltip: true, key: 'cn' },
      ],
      form: {
        "zh-cn_web_logo": "",
        "zh-tw_web_logo": "",
        en_web_logo: "",
        "zh-cn_about_us_address": "",
        "zh-tw_about_us_address": "",
        en_about_us_address: "",
        "zh-cn_about_us_email": "",
        "zh-tw_about_us_email": "",
        en_about_us_email: "",
        "zh-cn_about_us_hotline": "",
        "zh-tw_about_us_hotline": "",
        en_about_us_hotline: "",
        "zh-cn_about_us_fax": "",
        "zh-tw_about_us_fax": "",
        en_about_us_fax: "",
        "zh-tw_terms_of_use": "",
        "zh-cn_terms_of_use": "",
        en_terms_of_use: "",
        copyright: "",
        homepage: "",
      },
      form2: {
        en_about_us: "",
        "zh-cn_about_us": "",
        "zh-tw_about_us": "",
        "zh-cn_user_agreement": "",
        "zh-tw_user_agreement": "",
        en_user_agreement: "",
        "zh-cn_base_private_privacy": "",
        "zh-tw_base_private_privacy": "",
        en_base_private_privacy: "",
        "zh-cn_base_tnc": "",
        "zh-tw_base_tnc": "",
        en_base_tnc: "",
        "zh-cn_meta_desription": "",
        "zh-tw_meta_desription": "",
        en_meta_desription: "",
        "zh-cn_meta_key_words": "",
        "zh-tw_meta_key_words": "",
        en_meta_key_words: "",
        "zh-cn_agreement": "",
        "zh-tw_agreement": "",
        en_agreement: "",
      },
      data: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      data7: [],
      data8: [],
      data9: [],
      data2: [
        { title: this.$t('addrs'), en: "", tw: "", cn: '' },
        { title: this.$t('email'), en: "", tw: "", cn: '' },
        { title: this.$t('hotline'), en: "", tw: "", cn: '' },
        { title: this.$t('fax'), en: "", tw: "", cn: '' }
      ],
      modal: false,
      modal2: false,
      type: 1,
    };
  },
  created () {
    this.info();
  },
  mounted () { this.$base.setMenuOpens(); },
  methods: {
    info () {
      this.$base.showLoading();
      this.$request.sendPost('base-info/before-upd', {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.form.homepage = data.homepage
          this.form.copyright = data.copyright
          this.form.en_terms_of_use = data.en_terms_of_use
          this.form["zh-cn_terms_of_use"] = data["zh-cn_terms_of_use"]
          this.form["zh-tw_terms_of_use"] = data["zh-tw_terms_of_use"]
          this.form.en_about_us_fax = data.en_about_us_fax
          this.form["zh-tw_about_us_fax"] = data["zh-tw_about_us_fax"]
          this.form["zh-cn_about_us_fax"] = data["zh-cn_about_us_fax"]
          this.form.en_about_us_hotline = data.en_about_us_hotline
          this.form["zh-tw_about_us_hotline"] = data["zh-tw_about_us_hotline"]
          this.form["zh-cn_about_us_hotline"] = data["zh-cn_about_us_hotline"]
          this.form.en_about_us_email = data.en_about_us_email
          this.form["zh-tw_about_us_email"] = data["zh-tw_about_us_email"]
          this.form["zh-cn_about_us_email"] = data["zh-cn_about_us_email"]
          this.form.en_about_us_address = data.en_about_us_address
          this.form["zh-tw_about_us_address"] = data["zh-tw_about_us_address"]
          this.form["zh-cn_about_us_address"] = data["zh-cn_about_us_address"]
          this.form.en_web_logo = data.en_web_logo
          this.form["zh-tw_web_logo"] = data["zh-tw_web_logo"]
          this.form["zh-cn_web_logo"] = data["zh-cn_web_logo"]
          this.form2.en_about_us = data.en_about_us
          this.form2["zh-cn_about_us"] = data["zh-cn_about_us"]
          this.form2["zh-tw_about_us"] = data["zh-tw_about_us"]
          this.form2["zh-cn_user_agreement"] = data["zh-cn_user_agreement"]
          this.form2["zh-tw_user_agreement"] = data["zh-tw_user_agreement"]
          this.form2.en_user_agreement = data.en_user_agreement
          this.form2["zh-cn_base_private_privacy"] = data["zh-cn_base_private_privacy"]
          this.form2["zh-tw_base_private_privacy"] = data["zh-tw_base_private_privacy"]
          this.form2.en_base_private_privacy = data.en_base_private_privacy
          this.form2.en_base_tnc = data.en_base_tnc
          this.form2["zh-tw_base_tnc"] = data["zh-tw_base_tnc"]
          this.form2["zh-cn_base_tnc"] = data["zh-cn_base_tnc"]
          this.form2.en_meta_desription = data.en_meta_desription
          this.form2["zh-tw_meta_desription"] = data["zh-tw_meta_desription"]
          this.form2["zh-cn_meta_desription"] = data["zh-cn_meta_desription"]
          this.form2.en_meta_key_words = data.en_meta_key_words
          this.form2["zh-tw_meta_key_words"] = data["zh-tw_meta_key_words"]
          this.form2["zh-cn_meta_key_words"] = data["zh-cn_meta_key_words"]
          this.form2.en_agreement = data.en_agreement
          this.form2["zh-tw_agreement"] = data["zh-tw_agreement"]
          this.form2["zh-cn_agreement"] = data["zh-cn_agreement"]
          this.getForm()
        }
      );
    },
    save (e) {
      this.$base.showLoading();
      this.$request.sendPost('base-info/upd', e,
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.info()
        }
      );
    },
    save2 (e) {
      let obj = {}
      let item = {}
      if (this.type == 3) {
        item.en_base_private_privacy = e.en_base_private_privacy
        item['zh-cn_base_private_privacy'] = e['zh-cn_base_private_privacy'],
          item['zh-tw_base_private_privacy'] = e['zh-tw_base_private_privacy'],
          obj = item
      } else if (this.type == 2) {
        item.en_user_agreement = e.en_user_agreement
        item['zh-cn_user_agreement'] = e['zh-cn_user_agreement'],
          item['zh-tw_user_agreement'] = e['zh-tw_user_agreement'],
          obj = item
      } else if (this.type == 4) {
        item.en_base_tnc = e.en_base_tnc
        item['zh-cn_base_tnc'] = e['zh-cn_base_tnc'],
          item['zh-tw_base_tnc'] = e['zh-tw_base_tnc'],
          obj = item
      } else if (this.type == 5) {
        item.en_about_us = e.en_about_us
        item['zh-cn_about_us'] = e['zh-cn_about_us'],
          item['zh-tw_about_us'] = e['zh-tw_about_us'],
          obj = item
      } else if (this.type == 6) {
        item.en_meta_desription = e.en_meta_desription
        item['zh-cn_meta_desription'] = e['zh-cn_meta_desription'],
          item['zh-tw_meta_desription'] = e['zh-tw_meta_desription'],
          obj = item
      } else if (this.type == 7) {
        item.en_meta_key_words = e.en_meta_key_words
        item['zh-cn_meta_key_words'] = e['zh-cn_meta_key_words'],
          item['zh-tw_meta_key_words'] = e['zh-tw_meta_key_words'],
          obj = item
        obj = item
      } else if (this.type == 8) {
        item.en_agreement = e.en_agreement
        item['zh-cn_agreement'] = e['zh-cn_agreement'],
          item['zh-tw_agreement'] = e['zh-tw_agreement'],
          obj = item
      } else obj = e
      this.$base.showLoading();
      this.$request.sendPost('base-info/upd_item', obj,
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.info()
        }
      );
    },
    getForm () {
      let arr = [{ en: this.form2.en_base_tnc, tw: this.form2['zh-tw_base_tnc'], cn: this.form2['zh-cn_base_tnc'] }]
      this.data = arr
      arr = [{ en: this.form2.en_user_agreement, tw: this.form2['zh-tw_user_agreement'], cn: this.form2['zh-cn_user_agreement'] }]
      this.data3 = arr
      arr = [{ en: this.form2.en_base_private_privacy, tw: this.form2['zh-tw_base_private_privacy'], cn: this.form2['zh-cn_base_private_privacy'] }]
      this.data4 = arr
      arr = [{ en: this.form.en_terms_of_use, tw: this.form['zh-tw_terms_of_use'], cn: this.form['zh-cn_terms_of_use'] }]
      this.data5 = arr
      arr = [{ en: this.form2.en_about_us, tw: this.form2['zh-tw_about_us'], cn: this.form2['zh-cn_about_us'] }]
      this.data6 = arr
      arr = [{ en: this.form2.en_meta_desription, tw: this.form2['zh-tw_meta_desription'], cn: this.form2['zh-cn_meta_desription'] }]
      this.data7 = arr
      arr = [{ en: this.form2.en_meta_key_words, tw: this.form2['zh-tw_meta_key_words'], cn: this.form2['zh-cn_meta_key_words'] }]
      this.data8 = arr
      arr = [{ en: this.form2.en_agreement, tw: this.form2['zh-tw_agreement'], cn: this.form2['zh-cn_agreement'] }]
      this.data9 = arr
      this.data2[0].en = this.form.en_about_us_address
      this.data2[0].tw = this.form['zh-tw_about_us_address']
      this.data2[0].cn = this.form['zh-cn_about_us_address']
      this.data2[1].en = this.form.en_about_us_email
      this.data2[1].tw = this.form['zh-tw_about_us_email']
      this.data2[1].cn = this.form['zh-cn_about_us_email']
      this.data2[2].en = this.form.en_about_us_hotline
      this.data2[2].tw = this.form['zh-tw_about_us_hotline']
      this.data2[2].cn = this.form['zh-cn_about_us_hotline']
      this.data2[3].en = this.form.en_about_us_fax
      this.data2[3].cn = this.form['zh-cn_about_us_fax']
      this.data2[3].tw = this.form['zh-tw_about_us_fax']
    },
    handleClick (type) {
      this.type = type
      this.obj = this.form
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    contactUsClick (type) {
      this.type = type
      if (type == 1) this.obj = this.form
      else this.obj = this.form2
      this.modal2 = true
    },
    cancel2 () {
      this.modal2 = false
    },
    handleBeforeUpload (file, num) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          switch (num) {
            case 1:
              this.form.en_web_logo = res.url
              break;
            case 2:
              this.form['zh-tw_web_logo'] = res.url
              break;
            case 3:
              this.form['zh-cn_web_logo'] = res.url
              break;
          }
          this.save(this.form)
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .cardlist {
  padding: 30px 10px;
  .ivu-form-item {
    margin-bottom: 30px;
  }
  .photo_tip {
    color: #c5c8ce;
    font-size: 13px;
  }
  .uploadList {
    width: 250px;
    .list_title {
      width: 100%;
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
  .ivu-upload-drag {
    height: 102px;
  }
  .demo-upload-list {
    display: inline-block;
    width: 250px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-form .ivu-form-item-label {
    padding: 7px 3px 7px 0;
  }
  .ivu-form-item-label,
  .item_title {
    font-weight: bold;
    font-size: 16px;
  }
  .copyrightList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
  }
  .edit {
    text-align: right;
    padding-right: 5px;
  }

  .condition {
    margin-left: 100px;
  }
  .ivu-table th {
    background-color: #09684a;
    color: #fff;
    padding: 10px 0;
  }
  .table_title {
    font-size: 18px;
    padding: 0 20px 10px 0;
    font-weight: bold;
  }
  .formItem {
    margin-bottom: 0;
  }
  .contactUs {
    .ivu-table-row {
      td:first-child {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/info/info.vue